import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const scrollNow = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const scrollContainers = document.querySelectorAll(
        ".main-content, .admin-content, .content-wrapper, #root",
      );

      scrollContainers.forEach((el) => {
        if (el instanceof HTMLElement) {
          el.scrollTop = 0;
        }
      });
    };

    scrollNow();

    const timer = window.setTimeout(scrollNow, 80);

    return () => window.clearTimeout(timer);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
